import styled from 'styled-components'
import { theme } from '@/client/components'
const { color, space, breakpoint } = theme

export const Container = styled.div``
export const UploadContainer = styled.div``

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`

export const Option = styled.div<{ direction?: string; isFull?: boolean; disabled: boolean }>`
  display: flex;
  flex-direction: ${(p) => p.direction ?? 'row'};
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: ${(p) => (p.isFull ? 'nowrap' : 'wrap')};
  gap: ${space.sm};

  .upload-button {
    background-color: ${(p) => (p.disabled ? color.grayscale.gray : color.warning.pure)};
    border-color: ${(p) => (p.disabled ? color.grayscale.gray : color.warning.pure)};
    color: ${color.grayscale.darker};
  }
`

export const DragContainer = styled.div<{ disabled: boolean }>`
  .upload-icon {
    opacity: 0.1;
  }
  .drag-text {
    opacity: ${(p) => (p.disabled ? '0.2' : '1')};
  }
`

export const DividerLine = styled.div`
  background-color: ${color.grayscale.gray};
  margin-top: ${space.lg};
  margin-right: ${space.lg};
  margin-left: ${space.lg};
  width: 90%;
  height: 0.09rem;

  @media (min-width: ${breakpoint.md}) {
    background-color: ${color.grayscale.gray};
    margin-top: ${space.lg};
    margin-right: 0;
    margin-left: 0;
    width: 100%;
    height: 0.06rem;
  }
`
export const PreviewContainer = styled.div`
  margin: ${space.md} 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;

  .preview-filename {
    width: 50%;
  }
  button {
    border-color: transparent;
    background-color: transparent;
    padding: 0;
    font-size: 0.4rem;
    height: 1.5rem;
  }
`
export const ErrorResult = styled.div`
  .error-list-item {
    color: #f92626;
  }
`

export const ArtworkService = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${space.md};
  background-color: #efe5ff;
  align-items: center;
  width: 110%;

  .artwork-service-icon {
    padding-top: 1rem;
    padding-right: 1rem;
  }

  @media (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    align-items: center;
    width: 100%;
  }
`
export const SucessResult = styled.div`
  .sucess-text {
    color: #468936;
  }
`
